{
  "hero": {
    "eyebrow": "Projet étudiant en génie · Vancouver, Canada",
    "title": "AquaWorks — suivi de la qualité de l'eau.",
    "subtitle": "AquaWorks est un projet d'ingénierie mené par des étudiants, développé par des étudiants de l'Université de la Colombie-Britannique. Ce site est situé sur le campus de Vancouver de l'Université de la Colombie-Britannique.",
    "ctaPrimary": "Rejoindre l'équipe",
    "ctaSecondary": "Explorer le projet",
    "legend": "Assisté par radar · supervision à distance"
  },
  "status": {
    "items": [
      { "value": "Phase 1", "label": "Fenêtre de construction", "note": "Septembre–décembre 2026" },
      { "value": "5", "label": "Indicateurs clés", "note": "Température, pH, turbidité, conductivité, OD" },
      { "value": "4", "label": "Équipes étudiantes", "note": "Logiciel, Électricité, Mécanique, Affaires" },
      { "value": "Janv. 2027", "label": "Rapport de passation", "note": "Archive pour les prochaines équipes étudiantes" }
    ]
  },
  "identity": {
    "title": "Qu'est-ce qu'AquaWorks ?",
    "body": "AquaWorks — aussi connu sous le nom d'AquaWork — est un projet d'ingénierie mené par des étudiants, développé par des étudiants de l'Université de la Colombie-Britannique. Cette page d'accueil est l'index d'aquawork.ca, situé sur le campus de Vancouver de l'Université de la Colombie-Britannique, pour l'équipe qui construit un robot de surveillance de la qualité de l'eau assisté par radar."
  },
  "pillars": {
    "title": "Ce que livre la Phase 1",
    "lead": "Un prototype pratique pour des tests en eau stagnante contrôlée — ni brochure, ni substitut à l'analyse en laboratoire.",
    "panels": {
      "platform": {
        "kicker": "01 / Plateforme",
        "title": "Robot flottant modulaire",
        "body": "Flottabilité, propulsion, électronique étanche, distance assistée par radar et récupération sécurisée à terre."
      },
      "sense": {
        "kicker": "02 / Capteurs",
        "title": "Cinq indicateurs de qualité de l'eau",
        "body": "Capteurs interchangeables avec notes d'étalonnage, horodatage et référence spatiale pour chaque enregistrement."
      },
      "viz": {
        "kicker": "03 / Visualiser",
        "title": "Trajets, tendances, espace",
        "body": "Des journaux CSV deviennent cartes de trajet, courbes temporelles et au moins une visualisation spatiale."
      }
    }
  },
  "roadmap": {
    "title": "Une trajectoire par phases au-delà de l'eau stagnante",
    "lead": "La Phase 1 pose les bases. Les phases suivantes visent le suivi près du rivage et par zone — seulement avec permission, revue de sécurité et financement additionnel.",
    "cta": "Voir la feuille de route"
  },
  "context": {
    "title": "Pourquoi un suivi mobile compte sur le campus de Vancouver",
    "body": "La qualité des eaux pluviales et le changement lié aux pluies sont des priorités campus. Les stations fixes et les plans SEEDS comptent — AquaWorks ajoute des observations répétables, liées au lieu, le long d'un trajet défini.",
    "cta": "Lire la science"
  },
  "sdgs": {
    "title": "Objectifs de développement durable alignés",
    "items": {
      "education": "Éducation de qualité",
      "water": "Eau propre et assainissement",
      "innovation": "Industrie, innovation et infrastructure",
      "cities": "Villes et communautés durables",
      "consumption": "Consommation et production responsables",
      "climate": "Mesures relatives à la lutte contre les changements climatiques",
      "lifeBelowWater": "Vie aquatique",
      "partnerships": "Partenariats pour la réalisation des objectifs"
    }
  },
  "cta": {
    "title": "Aidez à bâtir une plateforme de surveillance réutilisable.",
    "body": "Des étudiants en génie et en affaires façonnent AquaWorks. Rejoignez une sous-équipe, conseillez les méthodes, ou suivez le journal de construction.",
    "button": "Nous contacter"
  }
}
